import { CaretRightIcon } from '@phosphor-icons/react/dist/ssr';

import { cn } from '@/lib/utils';
import { useNavStack } from '@/lib/nav-stack';

/**
 * Breadcrumb visual do Mini App — espelha o `≡ Início` do bot quando o
 * usuário está a 3+ níveis de profundidade. Em depth ≤ 2 fica oculto
 * (o BackButton nativo do Telegram já cobre).
 *
 * Renderiza só os labels (segmentos sem label viram "…" pra não poluir).
 * Cada segmento exceto o último é clicável e navega via `useNavStack`.
 */
export function NavBar({ className }: { className?: string }) {
  const { stack, depth, back, home } = useNavStack();
  if (depth <= 2) return null;

  const trail = stack.slice(0, -1);
  const current = stack[stack.length - 1];

  return (
    <nav
      aria-label="Breadcrumb"
      className={cn(
        'flex items-center gap-1.5 text-[11px] text-muted-foreground',
        'rounded-full bg-muted/30 px-3 py-1.5 ring-1 ring-border/50',
        'overflow-x-auto whitespace-nowrap',
        className,
      )}
    >
      <button
        type="button"
        onClick={home}
        className="font-medium text-primary hover:text-primary/80"
      >
        ≡ Início
      </button>
      {trail.slice(1).map((entry, i) => {
        const isLastTrail = i === trail.length - 2;
        return (
          <span key={`${entry.path}-${i}`} className="inline-flex items-center gap-1.5">
            <CaretRightIcon weight="bold" className="size-3 text-muted-foreground/60" />
            {isLastTrail ? (
              <button
                type="button"
                onClick={back}
                className="hover:text-foreground"
              >
                {entry.label ?? '…'}
              </button>
            ) : (
              <span className="text-muted-foreground/70">{entry.label ?? '…'}</span>
            )}
          </span>
        );
      })}
      <CaretRightIcon weight="bold" className="size-3 text-muted-foreground/60" />
      <span className="font-medium text-foreground">{current.label ?? '…'}</span>
    </nav>
  );
}
